import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import * as crushActions from 'lib/store/crushes'
import * as appActions from 'lib/store/app'
import * as userActions from 'lib/store/user'
import ReportModal from 'components/modal/ReportModal'
import CrushProfile from './CrushProfile'

export class CrushProfileContainer extends React.Component {
  static propTypes = {
    isMatch: PropTypes.bool,
    fetchProfile: PropTypes.func.isRequired,
    fetchUserProfile: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    likeCrush: PropTypes.func.isRequired,
    dislikeCrush: PropTypes.func.isRequired,
    reportCrush: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    userProfile: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // `match` from react-router, not a "Crushapp-Match".
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  static defaultProps = {
    isMatch: false
  }

  state = {
    showReportModal: false
  }

  componentDidMount() {
    document.title = 'Profile'

    Promise.all([
      this.props.fetchUserProfile(),
      this.props.fetchProfile(this.getCrushId())
    ]).then(() => {
      const { userLink } = this.props.userProfile
      if (!userLink && this.props.isMatch) {
        this.props.history.replace('/login', {
          referrer: this.props.location.pathname
        })
        return
      }

      this.props.setLoading(false)
    })
  }

  getCrushId = () => {
    return this.props.match.params.id
  }

  handleLike = () => {
    this.props.likeCrush(this.getCrushId())
    this.props.history.replace('/likedislike')
  }

  handleDislike = () => {
    this.props.dislikeCrush(this.getCrushId())
    this.props.history.replace('/likedislike')
  }

  navigateTo = url => {
    window.location.href = url
  }

  handleFacebook = () => {
    const { facebookId, userLink } = this.props.profile
    const targetUrl = facebookId
      ? `https://www.facebook.com/${facebookId}`
      : userLink

    this.navigateTo(targetUrl)
  }

  handleMessenger = () => {
    const { facebookId, userLink } = this.props.profile
    const targetUrl = facebookId ? `https://m.me/${facebookId}` : userLink

    this.navigateTo(targetUrl)
  }

  handleReport = () => {
    this.showReportModal(true)
  }

  handleReportReason = report => () => {
    this.props.reportCrush(this.getCrushId(), report)

    if (this.props.isMatch) {
      this.props.history.replace('/matches')
    } else {
      this.props.history.replace('/likedislike')
    }
  }

  showReportModal = isVisible => {
    this.setState({ showReportModal: isVisible })
  }

  handleModalClose = () => {
    this.showReportModal(false)
  }

  render() {
    const { profile, isLoading, isMatch } = this.props
    const { showReportModal } = this.state
    if (isLoading) return null

    return (
      <React.Fragment>
        {showReportModal && (
          <ReportModal
            onOutClick={this.handleModalClose}
            onClose={this.handleModalClose}
            onReport={this.handleReportReason}
          />
        )}
        <CrushProfile
          {...profile}
          isMatch={isMatch}
          onLike={this.handleLike}
          onDislike={this.handleDislike}
          onReportClick={this.handleReport}
          onFacebook={this.handleFacebook}
          onMessenger={this.handleMessenger}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.app.isLoading,
  profile: state.crushes.entities[ownProps.match.params.id] || {},
  userProfile: state.user.profile
})

const mapDispatchToProps = dispatch => ({
  setLoading: loadingState => dispatch(appActions.setLoading(loadingState)),
  fetchProfile: userId => dispatch(crushActions.fetchCrush(userId)),
  likeCrush: crushId => dispatch(crushActions.likeCrush(crushId)),
  dislikeCrush: crushId => dispatch(crushActions.dislikeCrush(crushId)),
  fetchUserProfile: () => dispatch(userActions.fetchUserProfile()),
  reportCrush: (crushId, report) =>
    dispatch(crushActions.reportCrush(crushId, report))
})

export const CrushProfileConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
  undefined,
  {
    pure: false
  }
)(CrushProfileContainer)

export default withRouter(CrushProfileConnected)



// WEBPACK FOOTER //
// ./src/components/profile/CrushProfileContainer.js